module.exports = __webpack_public_path__ + "static/media/Explore_User_Guide_Icon.fc1e63bd.svg";